import axios from 'axios'
import appConfig from 'appConfig'

const axiosInstance = axios.create({
  baseURL: appConfig.baseUrl || window.location.origin,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage[`brandAppV2-${appConfig.baseUrl == null ? "prod" : appConfig.baseUrl}-apiToken`]
  }
})

export const PayAPI = {

    startSimplePay: function (data) {
      return axiosInstance.request({
        method: "POST",
        url: `/api/v1/payment/simplePay/start`,
        data: JSON.stringify(data)
      })
    },
    startRafiPay: function (data) {
      return axiosInstance.request({
        method: "POST",
        url: `/api/v1/payment/raiffeisenPay/initRtp`,
        data: JSON.stringify(data)
      })
    },
    startOkePay: function (data) {
      return axiosInstance.request({
        method: "POST",
        url: `/api/v1/payment/okepay/start`,
        data: JSON.stringify(data)
      })
    },
    queryOkePay: async function (paymentType, paymentID) {
      try {
        let result = await axiosInstance.request({
          method: "GET",
          url: `/api/v1/payment/okepay/query/${paymentType}/${paymentID}`,
        })

        return result.data
      } catch(e) {
        console.log(e)
        return {success: false, message: "Error!"}
      }
    }
}